import { LeftOutlined } from '@ant-design/icons'

import Link from '~/core/Link'
import { ADMIN_PATH } from '~/redux-modules/preferences'

type AdminDashboardLink = {
    placement: string
}

const NAME = 'back-to-admin-home'

export default function AdminDashboardLink({ placement }: AdminDashboardLink) {
    return (
        <Link
            data-test-target={`${NAME}-${placement}`}
            to={ADMIN_PATH}
            name={NAME}
            placement={placement}
        >
            <LeftOutlined /> Internal Tools
        </Link>
    )
}
